import Navigation from 'modules/_navigation'
import Print from 'modules/_print'
import LazyLoad from 'modules/_lazy-load'
import Accordion from 'modules/_accordion'
import FeatureTables from 'modules/_feature-table'
import ArticleSliders from 'modules/_article-slider'
import Modals from 'modules/_modals'
import ArticleArchive from 'modules/_article-archive'
import QuoteSlider from 'modules/_quote-slider'
import HoverEffect from 'modules/_hover-effect'
import VideoModal from 'modules/_video-modal'
import CoverSliders from 'modules/_cover-slider'
import CoverVideos from 'modules/_cover-video'
import Sticky from 'modules/_sticky'
import FilterCars from 'modules/_filter-cars'
import LocalMenu from 'modules/_local-menu'
import GallerySlider from 'modules/_gallery-slider'
import Dealers from 'modules/_dealers'
import GalleryWidgets from './modules/_gallery-widgets'
import ListSection from './modules/_list-section'
import TextImageVariant from './modules/_text-image-variant'
import PriceTable from "modules/_price-table";
import ProductShowcase from "./modules/_product-showcase";
import ObjectFitClass from "utils/_object-fit";
import cssVars from "css-vars-ponyfill";

/* Run polyfills
 ---------------------------------------------------------- */
require('./polyfills/_closest')
require('./polyfills/_for-each')
require('./polyfills/_includes')

/* Register modules
 ---------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  (new Navigation).ready();
  new ObjectFitClass();
  (new Print).ready();
  (new LazyLoad).ready();
  (new Accordion).ready();
  (new FeatureTables).ready();
  (new ArticleSliders).ready();
  (new Modals).ready();
  (new ArticleArchive).ready();
  (new QuoteSlider).ready();
  (new HoverEffect).ready();
  (new VideoModal).ready();
  (new CoverSliders).ready();
  (new CoverVideos).ready();
  (new Sticky).ready();
  (new FilterCars).ready();
  (new LocalMenu).ready();
  (new GallerySlider).ready();
  (new Dealers).ready();
  (new GalleryWidgets).ready();
  cssVars();
  (new ListSection).ready();
  (new TextImageVariant).ready();
  (new PriceTable).ready();
  (new ProductShowcase).ready();
});

// require('./app');
